// SME Grant, Corporate Grant, Social Enterprise Grant, and SEDF Enterprise Grant
// share the same backend table/model, distinguished by the grant_type column.
// This config drives the SME wizard/list components
export const GRANT_TYPE_CONFIG = {
  sme: {
    grantTypeValue: "SME",
    shortLabel: "SME",
    apiBase: "sme-grants",
    routeBase: "sme-grant",
    label: "SME Grant",
    permissionPrefix: "sme-grant",
    attachmentPermissionPrefix: "sme-grants-attachment",
  },
  corporate: {
    grantTypeValue: "Corporate",
    shortLabel: "Corporate",
    apiBase: "corporate-grants",
    routeBase: "corporate-grant",
    label: "Corporate Grant",
    permissionPrefix: "corporate-grant",
    attachmentPermissionPrefix: "corporate-grants-attachment",
  },
  "social-enterprise": {
    grantTypeValue: "Social Enterprise",
    shortLabel: "Social Enterprise",
    apiBase: "social-enterprise-grants",
    routeBase: "social-enterprise-grant",
    label: "Social Enterprise Grant",
    permissionPrefix: "social-enterprise-grant",
    attachmentPermissionPrefix: "social-enterprise-grants-attachment",
  },
  "sedf-enterprise": {
    grantTypeValue: "SEDF Enterprise",
    shortLabel: "SEDF Enterprise",
    apiBase: "sedf-enterprise-grants",
    routeBase: "sedf-enterprise-grant",
    label: "SEDF Enterprise Grant",
    permissionPrefix: "sedf-enterprise-grant",
    attachmentPermissionPrefix: "sedf-enterprise-grants-attachment",
  },
};

export const getGrantTypeConfig = (grantType) =>
  GRANT_TYPE_CONFIG[grantType] || GRANT_TYPE_CONFIG.sme;
